// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"35b90b2c","213":"6bf3cd25","239":"8dbbc924","455":"05a4ea98","885":"eef1c7f0","947":"5884569c"}[chunkId] + ".chunk.js";
};